import type { CartItem, CartOrderDetails, CreateOrderPayload } from "../types/orders";

export function buildCreateOrderPayload(
  cart: CartItem[],
  orderDetails: CartOrderDetails & { customer_id: number },
  notes?: string | null
): CreateOrderPayload {
  return {
    customer_id: orderDetails.customer_id,
    po_number: orderDetails.po_number,
    expected_date: orderDetails.expected_date,
    notes,
    products: cart.map(({ id, quantity, price, discount, tax_rate, notes: itemNotes }) => ({
      product_id: id,
      quantity,
      price,
      discount,
      tax_rate,
      notes: itemNotes,
    })),
  };
}
